export const DEFAULT_STEP = 1;

/**
 * Timestamp which is one-sixtieth of a second to provide 60 fps.
 * */
export const ANIMATION_WAIT_MS = 16.6;

export enum Bound {
	Min = 'min',
	Max = 'max',
}

export enum KeyboardEventKey {
	Enter = 'Enter',
	PageUp = 'PageUp',
	PageDown = 'PageDown',
	End = 'End',
	Home = 'Home',
	ArrowLeft = 'ArrowLeft',
	ArrowUp = 'ArrowUp',
	ArrowRight = 'ArrowRight',
	ArrowDown = 'ArrowDown',
}

export const BOUNDS = [Bound.Min, Bound.Max];

export const RANGE_TEST_ID = 'rangeTestId';
export const RANGE_DUAL_TEST_ID = 'rangeDualTestId';
export const RANGE_TRACK_TEST_ID = 'rangeTrackTestId';
export const RANGE_INPUT_SECTION_TEST_ID = 'rangeInputSectionTestId';
export const RANGE_DUAL_INPUT_SECTION_TEST_ID = 'rangeDualInputSectionTestId';
export const RANGE_INPUT_TEST_ID = 'rangeInputTestId';
export const RANGE_THUMB_ROLE = 'slider';
